import { environment } from '../../../../../environments/environment';

export const RELEASE_ONBOARDING_CONFIG = {
  ...environment.releaseOnboarding,
  requiredDriverTours: [
    'Home-onboarding',
    'open-SimilarProject-onboarding',
    'QuestionSet-Selected-Form-onboarding',
    'PillsKnowledge-onboarding',
    'OpenSearch-onboarding',
    'view_-response_opensearch',
    'DraftLesson-onboarding',
    'Footer-onboarding',
  ],
} as const;

export function hasCompletedToursBeforeDeployment(
  tourKeys: readonly string[],
  getCompletedAt: (key: string) => number | null,
  deploymentTimestamp: number,
): boolean {
  return (
    tourKeys.length > 0 &&
    tourKeys.every(key => {
      const completedAt = getCompletedAt(key);
      return completedAt !== null && completedAt < deploymentTimestamp;
    })
  );
}
